<template>
    <div class="topcreate row">
        <div class="content-container">

            <div class="header"><div class="title">Create Topic in {{ selectedBoardName }}</div> </div>

            <div class="content form-content">

                <form @submit.prevent="fakeSubmit">
                    <div class="edit-row"><div class="caption">Board:</div>
                        <select v-model="boardSelectionList.selected" class="select-wide">
                            <optgroup v-bind:key="category.id" v-for="category in boardSelectionList.options" v-bind:label="category.name">
                                <option v-bind:key="board.id" v-for="board in category.boards" v-bind:value="board">{{ board.name }}</option>
                            </optgroup>
                        </select>
                    </div>
                    <div class="edit-row"><div class="caption">Title:</div><div class="input-title"><input v-model="title" type="text" /></div></div>
                    <div class="edit-row" v-if="tags && tags.length > 0">
                      <div class="caption">Tags:</div>
                         <multiselect class="multi-select-control" v-model="selectedTags" placeholder="Search a tag" label="name" track-by="id" :options="tags" :multiple="true" :taggable="false"></multiselect>
                    </div>
                    <div class="edit-row" v-if="canUpdateStatus">
                        <div class="caption">Status: </div>
                        <div>
                          <select v-model="status">
                            <option v-for="option in options" v-bind:value="option.value" :key="option.value">
                              {{ option.text }}
                            </option>
                          </select>
                        </div>
                    </div>
                    <div class="edit-row" v-if="canUpdateStatus">
                        <div class="caption">Pinned: </div>
                        <div>
                            <input type="checkbox" v-model="pinned" style="width: auto;">
                        </div>
                    </div>

                    <div class="edit-row"></div>
                    <div class="edit-row"></div>

                    <div v-if="showModeratedBanner" class="banner banner-warning">{{ moderatedBannerText }}</div>

                    <PostEditor ref="editor" v-bind="{
                        content: null,
                        cancel: this.cancel,
                        submit: this.submitTopic,
                        allowAttachments: true,
                        allowEditReason: false,
                        allowMentions: false
                    }" />
                    
                </form>
            </div>            
        </div>
    </div>
</template>


<script>

    import PostEditor from '../../components/Posts/PostEditor.vue'
    import Multiselect from 'vue-multiselect'
    import permissionHelper from '../../components/PermissionHelper'
    import api from '../../api/api';
    import common from '../../modules/common'
    import dialogs from '../../modules/dialogs'
import forumEnums from '../../store/models/forumEnums';
    
    export default {
        data() {
            return {
                boardSelectionList: {
                    options: null,
                    selected: null,
                },
                title: null,
                tags: [],
                selectedTags: [],
                pinned: false,
                status: null,
                moderatedBannerText: "This board is moderated.  Your topic will not be visible until approved.",
                options: [
                  {
                    text: 'Deleted',
                    value: 0,
                  }, {
                    text: 'Pending Approval',
                    value: 1,
                  }, {
                    text: 'Normal',
                    value: 2,
                  }, {
                    text: 'Moderated',
                    value: 3,
                  }, {
                    text: 'Locked',
                    value: 4,
                  },
                ],
            }
        },
        props: [
            'referringBoardID'
        ],
        components: {
            PostEditor,
            Multiselect
        },
        computed: {
            selectedBoardName: function() {
                if (this.boardSelectionList.selected === null) {
                    return '(no board selected)';
                } else {
                    return this.boardSelectionList.selected.name;
                }
            },
            canUpdateStatus: function() {
                let user = this.$store.getters.user;
                return permissionHelper.topics.setStatus(user);
            },
            showModeratedBanner: function() {
                let user = this.$store.getters.user;
                let board = this.boardSelectionList.selected;
                if (board !== null) {                    
                    var status = permissionHelper.topics.getStatus(user, board.type, board.topicModerationRoleThreshold);
                    if (status == forumEnums.topicStatusEnum.PENDINGAPPROVAL) return true;
                }                
                return false;
            }

        },
        methods: {
            fakeSubmit() {
                // this is here to handle the bug with the form
                // either refactor the form element out of the html above
                // or leave this here...
            },
            cancel() { this.$router.go(-1); },
            submitTopic(content, trackEditReason, editReason, done) {
                let topic = {
                    boardID: this.boardSelectionList.selected.id,
                    title: this.title,
                    content: content,
                    memberID: this.$store.getters.user.id,
                    tags: this.selectedTags.map(r=>r.id),
                }

                if(this.canUpdateStatus) {
                    topic = {
                        ...topic,
                        pinned: this.pinned || false,
                        status: this.status,
                    }
                }

                let valid = true;

                if (topic.title === null || topic.title === '') {
                    valid = false;
                }
                if (topic.content === null || topic.content === '') {
                    valid = false;
                }
                if (topic.boardID === null || topic.memberID === null) {
                    valid = false;
                } 
                if (!valid) {
                    dialogs.alertAsync('Invalid submission, check fields and try again');
                    return;
                }

                api.post('/topics/create', topic)
                    .then((response) => {
                        if (response.data.success === true) {
                            if (response.data.canAccessTopic) {
                                this.$router.replace('/topics/' + response.data.topicID);
                            } else {
                                dialogs.alertAsync("Your topic has been submitted and is pending approval");
                                this.$router.replace('/');
                            }
                            
                        } else {
                            dialogs.alertAsync(response.data.message);
                        }
                        done();
                    });

            },

            setBoardSelection: function(id) {
                var cats = this.boardSelectionList.options;
                for (var i = 0; i < cats.length; i++) {
                    for (var j = 0; j < cats[i].boards.length; j++) {
                        if (cats[i].boards[j].id === id) {
                            this.boardSelectionList.selected = cats[i].boards[j];
                        }
                    }
                }
            }
        },
        mounted() {      
            
            var bc = common.breadcrumb.create([
                { url: '/', text: 'UtterAccess' },
                { url: '/topics/create', text: 'Create Topic' }
            ]);
            this.$store.dispatch("breadcrumb", bc);        
                          
            api.get('/boards/selection?permission=createTopic')
                .then(response => {
                    this.boardSelectionList.options = response.data.categories;
                    if (this.referringBoardID) {
                        this.setBoardSelection(parseInt(this.referringBoardID))
                    }
                });

            if (this.canUpdateStatus) this.status = 2;  // default status, if able to edit...
        },

        created: function() {
          api.get('/tags').then(r=>  {
            this.tags = r.data;
          });
        }
    }
</script>

<style src='vue-multiselect/dist/vue-multiselect.min.css'></style>

